import io from "socket.io-client";
import api from "../services/api";


class SocketWorker {
  constructor(companyId, userId) {
    const sessionToken = api.defaults.headers.Authorization

    if (SocketWorker.instance) {
      const instance = SocketWorker.instance;
      // FIX: Atualiza o token na instância existente se mudou
      if (sessionToken && instance.token !== sessionToken) {
        console.log("SocketWorker: Atualizando token na instância Singleton");
        instance.token = sessionToken;
        instance.userId = userId;

        if (instance.socket) {
          instance.socket.io.opts.query = {
            userId: instance.userId,
            token: instance.token
          };

          if (!instance.socket.connected) {
            console.log("SocketWorker: Forçando reconexão com novo token");
            instance.socket.connect();
          }
        }
      }
      return SocketWorker.instance;
    }

    this.companyId = companyId
    this.userId = userId
    this.token = sessionToken
    this.socket = null;
    this.configureSocket();
    this.eventListeners = {};
    SocketWorker.instance = this;

    return SocketWorker.instance;
  }

  configureSocket() {
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}`, {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      // transports: ["websocket", "polling", "flashsocket"],
      // pingTimeout: 18000,
      // pingInterval: 18000,
      query: { userId: this.userId, token: this.token }
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("disconnect", () => {
      console.log("Desconectado do servidor Socket.IO");
      this.reconnectAfterDelay();
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {

    this.connect();
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    // console.log(event, callback)
    this.connect();
    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null
      this.instance = null
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  get connected() {
    return this.socket?.connected || false;
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;